import htmx from "htmx.org";
import { RangeSlider } from "./components/RangeSlider/RangeSlider";
import { JobsCount } from "./components/JobsCount/JobsCount";

document.addEventListener('DOMContentLoaded', () => {
    RangeSlider()
    //JobsCount()
})



htmx.on('htmx:afterSwap', function (event) {
    RangeSlider()
    //JobsCount()

    // scoll back to the jobs grid
    const targetElement = document.getElementById('jobs-grid')
    targetElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' })

})
